import { render, staticRenderFns } from "./LoadUpdateData.vue?vue&type=template&id=378b9b8a&"
import script from "./LoadUpdateData.vue?vue&type=script&lang=js&"
export * from "./LoadUpdateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports